var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"pa-4"},[_c('v-card-title',{staticClass:"text-subtitle-1 font-weight-bold justify-center"},[_vm._v(" Distribución de ingreso promedio semanal ")]),(_vm.loading)?[_c('v-skeleton-loader',{attrs:{"type":"image"}})]:(_vm.items.length && !_vm.loading)?_c('div',{staticClass:"d-flex justify-center"},[_c('donut-chart',{staticClass:"w-100",attrs:{"height":"350","items":_vm.items,"donut-hole":0.5,"only-positive-items":false,"options":{
          legend: {
            position: 'right',
            alignment: 'center',
          },
          tooltip: { text: 'label', isHtml: true },
          pieSliceText: 'percentage',
        }}})],1):_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }